import styled from 'foundations-theming/utils';
import { filterProps } from '../../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledTFoot = styled.tfoot.withConfig({
  displayName: "TableFoot__StyledTFoot",
  componentId: "p2r15t-0"
})(({
  theme,
  $cssStyles
}) => {
  return Object.assign({}, theme.typography['body-125'], $cssStyles);
});
export const TableFoot = props => {
  const {
    domProps,
    callbackProps,
    tokenProps,
    restProps
  } = filterProps(props);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledTFoot, Object.assign({}, domProps, callbackProps, restProps, {
    $cssStyles: cssStyles
  }));
};